(function () {
  var nativeFetch = window.fetch.bind(window);
  var busy = false;

  function routeRoot() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function drawerEl() { return document.querySelector('cart-drawer'); }

  function sectionIds() {
    var cd = drawerEl();
    if (cd && typeof cd.getSectionsToRender === 'function') {
      try { return cd.getSectionsToRender().map(function (s) { return s.id; }); } catch (e) {}
    }
    return null;
  }

  function openDrawer(json) {
    var cd = drawerEl();
    if (cd && json && json.sections && typeof cd.renderContents === 'function') {
      try { cd.renderContents(json); return true; } catch (e) {}
    }
    return false;
  }

  function add(btn) {
    if (busy) return;
    var id = parseInt(btn.getAttribute('data-mb-add'), 10);
    if (!id) return;
    busy = true;

    var original = btn.textContent;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = 'Agregando...';

    var payload = { items: [{ id: id, quantity: 1 }] };
    var ids = sectionIds();
    if (ids) { payload.sections = ids.join(','); payload.sections_url = window.location.pathname; }

    nativeFetch(routeRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) { return res.json(); })
      .then(function (json) {
        busy = false;
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        if (json && json.status && json.status !== 200) {
          btn.textContent = json.description || 'No disponible';
          setTimeout(function () { btn.textContent = original; }, 2600);
          return;
        }
        btn.textContent = original;
        if (!openDrawer(json)) { window.location = routeRoot() + 'cart'; }
        document.dispatchEvent(new CustomEvent('mb:cart:changed'));
      })
      .catch(function () {
        busy = false;
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        btn.textContent = original;
        window.location = routeRoot() + 'cart';
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-mb-add]') : null;
    if (!btn || btn.disabled) return;
    e.preventDefault();
    add(btn);
  });
})();
